import { PhoneOutlined } from "@ant-design/icons";
import { Input, Select, Space } from "antd";
import React, { useState, useEffect } from "react";

const EditPhoneNumber: React.FC<{
  prefix?: string;
  phoneNumber?: string;
  onChange?: (value: string) => void;
}> = ({ prefix = "6", phoneNumber = "", onChange }) => {
  const [localPrefix, setLocalPrefix] = useState(prefix);
  const [localPhoneNumber, setLocalPhoneNumber] = useState(phoneNumber);

  useEffect(() => {
    setLocalPrefix(prefix);
    setLocalPhoneNumber(formatPhoneNumberForDisplay(phoneNumber));
  }, [prefix, phoneNumber]);

  const formatPhoneNumberForDisplay = (value: string): string => {
    const digits = value.replace(/\D/g, "");
    const parts = [
      digits.slice(0, 2),
      digits.slice(2, 4),
      digits.slice(4, 6),
      digits.slice(6, 8),
    ];
    return parts.filter((part) => part.length > 0).join(" ");
  };

  const handlePrefixChange = (value: string) => {
    setLocalPrefix(value);
    handleChange(value + localPhoneNumber.replace(/\s/g, ""));
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhoneNumberForDisplay(e.target.value);
    setLocalPhoneNumber(formatted);
    handleChange("0" + localPrefix + e.target.value.replace(/\D/g, "")); // Continuous string without spaces
  };

  const handleChange = (value: string) => {
    onChange?.(value);
  };

  const prefixSelector = (
    <Select
      value={localPrefix}
      onChange={handlePrefixChange}
      style={{ width: 100 }}
    >
      <Select.Option value="5">+212 5</Select.Option>
      <Select.Option value="6">+212 6</Select.Option>
      <Select.Option value="7">+212 7</Select.Option>
    </Select>
  );

  return (
    <Space direction="vertical" size="small" style={{ display: "flex" }}>
      <Input
        value={localPhoneNumber}
        onChange={handlePhoneChange}
        addonBefore={prefixSelector}
        placeholder="xx xx xx xx"
        maxLength={11}
        style={{ width: "100%" }}
        prefix={<PhoneOutlined />}
      />
    </Space>
  );
};

export default EditPhoneNumber;
